// @givmo/app-charity — a tiny debounce hook.
//
// Returns `value` delayed by `delayMs` — the debounced echo used to throttle the org-search query so
// a request fires on a settled search term, not every keystroke. Framework-agnostic; no deps.

import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
}
